import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";


import { apiFetch } from "./apiFetch";

/**
 * Fetch visible column ids for a given table (scoped by account + user).
 * @param {string} accountId
 * @param {string} userId
 * @param {string} tableKey
 * @returns {Promise<string[] | null>} visible column ids or null when no preference is saved
 */
export async function fetchTablePreferences(accountId, userId, tableKey) {
  if (!accountId || !userId || !tableKey) return null;
  const resp = await apiFetch(serverInfo.serverUrl + "/getTablePreferences", {
    method: "POST",
    body: JSON.stringify({
      account_id: accountId,
      user_id: userId,
      table_key: tableKey,
    }),
  });
  checkResponse(resp);
  const data = await resp.json();
  if (!data || !Array.isArray(data.visible_columns)) return null;
  return data.visible_columns;
}

/**
 * Save visible column ids for a given table (scoped by account + user).
 * @param {string} accountId
 * @param {string} userId
 * @param {string} tableKey
 * @param {string[]} visibleColumns
 */
export async function saveTablePreferences(accountId, userId, tableKey, visibleColumns) {
  if (!accountId || !userId || !tableKey || !Array.isArray(visibleColumns)) {
    throw new Error("accountId, userId, tableKey and visibleColumns[] are required");
  }
  const resp = await apiFetch(serverInfo.serverUrl + "/saveTablePreferences", {
    method: "POST",
    body: JSON.stringify({
      account_id: accountId,
      user_id: userId,
      table_key: tableKey,
      visible_columns: visibleColumns,
    }),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Failed to save table preferences");
  }
}

